export * from "entries/constructors/pairs-test/routes";
